import { ChakraProvider, Center, Spinner } from '@chakra-ui/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import { VulnerabilityProvider } from './context/VulnerabilityContext';
import { UserPreferencesProvider } from './context/UserPreferencesContext';
import { theme } from './theme';
import Layout from './components/Layout';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const Dashboard = lazy(() => import('./pages/Dashboard'));
const VulnerabilityDetail = lazy(() => import('./pages/VulnerabilityDetail'));
const Comparison = lazy(() => import('./pages/Comparison'));

function FullScreenSpinner() {
  return (
    <Center minH="200px">
      <Spinner size="xl" thickness="4px" speed="0.8s" color="brand.500" />
    </Center>
  );
}

function App() {
  return (
    <ChakraProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <UserPreferencesProvider>
          <VulnerabilityProvider>
            <BrowserRouter>
              <Suspense fallback={<FullScreenSpinner />}>
                <Routes>
                  <Route element={<Layout />}>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/vulnerability/:id" element={<VulnerabilityDetail />} />
                    <Route path="/compare" element={<Comparison />} />
                  </Route>
                </Routes>
              </Suspense>
            </BrowserRouter>
          </VulnerabilityProvider>
        </UserPreferencesProvider>
      </QueryClientProvider>
    </ChakraProvider>
  );
}

export default App;

